export var UPDATE_SELECTED_SECTION = 'UPDATE_SELECTED_SECTION';
export var UPDATE_SELECTED_QUESTION_INDEX = 'UPDATE_SELECTED_QUESTION_INDEX';